import { connect } from 'react-redux'
import { useState, useEffect } from 'react'
import { doResendConfirmationToken } from 'ducks/currentUser/operations'

const perform = {
  onClick: doResendConfirmationToken,
}

const ResendToken = connect(null, perform)(({ onClick }) => {
  const [disabled, setDisabled] = useState(false)
  useEffect(
    () => {
      const timer = setTimeout(() => setDisabled(false), 60 * 1000)
      return () => clearTimeout(timer)
    },
    [disabled]
  )
  return (
    <React.Fragment>
      {disabled ? (
        <span>Code resent!</span>
      ) : (
        <a
          // eslint-disable-next-line react/jsx-no-bind
          onClick={() => {
            if (disabled) {
              return
            }
            setDisabled(true)
            onClick()
          }}
        >
          {disabled ? 'Code resent!' : 'Resend code'}
        </a>
      )}
    </React.Fragment>
  )
})

export default ResendToken
